module.exports = __webpack_public_path__ + "static/media/iep-ui-design04-thumb.35f697e8.png";